import { render, staticRenderFns } from "./Create-Quotation.vue?vue&type=template&id=d241b72a"
import script from "./Create-Quotation.vue?vue&type=script&lang=js"
export * from "./Create-Quotation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports